import React from 'react';
import styled from 'styled-components/macro';
import { Avatar, Row, Col } from 'antd';

import Description from 'components/Description/Description';
import Heading from 'components/Heading/Heading';

import BuildingStatusImage from './images/building-status-icon.png';
import DetailsImage from './images/details-icon.png';
import MatchSuitableHostImage from './images/match-suitable-host-icon.png';
import WebBackgroundImage from './images/web-bg.svg';

const StyledAvatar = styled(Avatar)`
  background-color: ${props => props.theme.color.white} !important;
  padding: 16px !important;
  font-size: 24px;

  @media (min-width: 992px) {
    height: 100px !important;
    width: 100px !important;
  }
`;
StyledAvatar.displayName = 'StyledAvatar';

const StyledContainer = styled(Row)`
  height: 100% !important;
  padding-top: 8% !important;
  padding-bottom: 8% !important;

  @media (min-width: 768px) {
    background: url(${WebBackgroundImage}) no-repeat center bottom;
    background-size: contain;
    flex-direction: column !important;
  }
`;

const StyledDiv = styled.div`
  margin-top: 0px !important;

  @media (min-width: 1200px) {
    margin-top: -32px !important;
  }
`;

const StyledColumn = styled(Col)`
  text-align: center;
  @media (min-width: 768px) {
    margin-bottom: 24px !important;
  }
`;

const Feature = () => (
  <>
    <StyledContainer type="flex">
      <Heading as="h4" size="sub" color="primary" align="center">
        3 Simple Steps To Get A Reliable Host
      </Heading>
      <Row type="flex" gutter={48} justify="center" align="top">
        <StyledColumn span={24} md={24} xl={6}>
          <StyledAvatar src={BuildingStatusImage} size={80} />
          <Description align="center">
            Check Building Status
            <br />& Search Hosts Near You
          </Description>
        </StyledColumn>
        <StyledColumn span={24} md={24} xl={6}>
          <StyledAvatar src={DetailsImage} size={80} />
          <Description align="center">
            Send Us Your
            <br />
            Details
          </Description>
        </StyledColumn>
        <StyledColumn span={24} md={24} xl={6}>
          <StyledAvatar src={MatchSuitableHostImage} size={80} />
          <Description align="center">
            Get Matched
            <br />
            with A Host
          </Description>
        </StyledColumn>
      </Row>
      <StyledDiv>
        <Description align="center">
          We understand the troubles in generating high rental yields for your properties. You can now sit back, relax, and watch your investment grow! <br />
          Search for top-rated hosts to manage your short stay properties for you.
        </Description>
        <Description align="center">
          HostAStay is the leading directory platform for finding reliable hosts. We ensure all hosts are vetted, so that you can have the best people
          to help you. <br />
          Leave your worries with professional, trusted & verified hosts today!
        </Description>
      </StyledDiv>
    </StyledContainer>
  </>
);

export default Feature;
